module.exports = __webpack_public_path__ + "img/drag-indicator.1388c316.svg";